import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { User } from 'api/models';
import { ApprovalRequested } from 'api/notifications/meta';
import { useGetAllActiveUsersMap } from 'hooks/use-idb';
import { Causer } from './causer';
import { UserListWithAvatar } from './user-list-with-avatar';

export const TaskApprovalRequest: FC<{
  meta: ApprovalRequested;
  approverIds: number[];
}> = ({ meta: { by }, approverIds }) => {
  const users = useGetAllActiveUsersMap();
  const approvers = approverIds.map((id) => users[id]) as User[];

  return (
    <FormattedMessage
      id="notifications.messages.approval_requested"
      values={{
        causer: <Causer user={by} />,
        approvers: <UserListWithAvatar users={approvers} />,
      }}
    />
  );
};
